module.exports = __webpack_public_path__ + "img/banner.bef15636.jpg";